exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-footer > div {\n  width: 100%;\n}\n", ""]);

// exports
